

import organizationsReducer from './OrganizationsReducer';
export { organizationsReducer }

export * from './OrganizationsActions';



// WEBPACK FOOTER //
// ./src/store/organizations/index.js